import { Verify } from 'pages/verify'

export const VerifyManagementRoute = () => {
  return <Verify />
}